const parseDateToUsModel = (date) => {
  const [day,month,year] = date.split("-");
  if(day && month && year) {
    return year+"-"+month+"-"+day;
  } else {
    return "";
  }
}
const SET_BIRTHS_CONSULTATIONS = (state, payload) => {
  payload.births.forEach(e => {
    e.birth.date = parseDateToUsModel(e.birth.date);
    e.birth.explanation_date = parseDateToUsModel(e.birth.explanation_date);
    e.services.forEach(serv => {
      serv.lactation = [serv.lactation];
      serv.date = parseDateToUsModel(serv.date);
    });
  });
  state.birthsConsultations = payload;
}
const SET_SELECTED_ANIMAL = (state, payload) => {
  state.selectedAnimal = payload
}
export default {
  SET_BIRTHS_CONSULTATIONS,
  SET_SELECTED_ANIMAL
}